import { makeStyles, createStyles } from "@material-ui/core";
import { IconButton } from "screens/Root/components/IconButton";
import BottomLine from "../common/BottomLine";
const useStyles = makeStyles(() => createStyles({
    button: {
        padding: "2px",
        width: 28,
        marginLeft: 8,
        "&:focus .MuiIcon-root": {
            boxShadow: "inset 0px 0px 5px 3px #45baff",
        },
    },
}));
const AddNewTabButton = () => {
    const classes = useStyles();
    const handleClick = () => window.RootExtensions?.FullSearchWindow?.open?.();
    return (<BottomLine>
      <IconButton tooltip="Add new tab" onClick={handleClick} identification="tabs-add-action" type="material-icons-outlined" className={classes.button} size={24} color="rgb(111, 111, 124)">
        add_circle
      </IconButton>
    </BottomLine>);
};
export default AddNewTabButton;
